module.exports = __webpack_public_path__ + "static/media/test10_1.a523f1c4.png";